import { useEffect } from 'react';

export const useThemeRipple = (isDarkMode?: boolean) => {
  useEffect(() => {
    const body = document.body;
    
    if (isDarkMode !== undefined) {
      body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    } else {
      // Auto-detect based on system preference if not specified
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      body.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
    }
  }, [isDarkMode]);
};